// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hJFR","col":"styles_col__A126A"};